const UPI_ID_REGEX = /^[a-zA-Z0-9._-]{2,256}@[a-zA-Z][a-zA-Z0-9.-]{1,63}$/;

export const sanitizeUpiId = (upiId = '') => String(upiId).trim().toLowerCase();

export const isValidUpiId = (upiId = '') => {
  const normalizedUpiId = sanitizeUpiId(upiId);
  if (!normalizedUpiId) return true;
  return UPI_ID_REGEX.test(normalizedUpiId);
};

export const getRazorpayMethodConfig = () => ({
  upi: true,
  card: true,
  netbanking: true,
  wallet: true,
  emi: true,
  paylater: true,
});

export const getRazorpayUpiPrefill = (prefill = {}, upiId = '') => {
  const normalizedUpiId = sanitizeUpiId(upiId);
  if (!normalizedUpiId) return prefill;

  return {
    ...prefill,
    method: 'upi',
    vpa: normalizedUpiId,
  };
};
